export default {"src":"/_next/static/media/cdc.9aee8ed5.svg","height":161,"width":161};